import { useEffect, useState } from "react";
import { SelectForCompany as SELECT } from "src/component/api/Dashboard/index";
import { LOGOUT } from "src/component/helper/constants";

const UseCompanyDashboard = () => {
  const [groupAdmin, setGroupAdmin] = useState(0);
  const [totalUser, setTotalUser] = useState(0);
  const [totalSubscribers, setSubscribers] = useState(0); 
  const [companyName, setCompanyName] = useState(""); 
  useEffect(() => {
    select();
  }, []);

  const select = async () => {
    const response = await SELECT();
    if (!response?.isAuthorized) LOGOUT();
    if (!response?.status) {
      return;
    }
    var data = JSON.parse(response?.data!); 
    setGroupAdmin(data.TotalGroupAdmin);
    setTotalUser(data.TotalUser); 
    setSubscribers(data.TotalSubscribers);
    setCompanyName(data.CompanyName);
  };

  return {
    groupAdmin,
    totalUser,
    companyName,
    totalSubscribers, 
  };
};
export default UseCompanyDashboard;
